import { Actions, CONFIG_ACTIONS } from "./config.type"

export const toogleDarkMode = (): Actions => ({
    type: CONFIG_ACTIONS.TOOGLE_DARK_MODE,
})
